<aa-chat
  [orderCardId]="data.orderCardId"
  [customerProfileId]="data.customerProfileId"
  [class.in-modal]="true"
  (close)="this.dialogRef.close()"></aa-chat>
